const BOXES = [0, 1, 2]

const createEmptyStake = () => ({
    ante: 0,
    blind: 0,
    trips: 0,
    bet: 0
})
const initialStake = [
    createEmptyStake(),
    createEmptyStake(),
    createEmptyStake()
]

export { BOXES, createEmptyStake, initialStake }